import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Updatable, Vendor, VendorTaskListRow, updateInList } from 'shared';
import { VendorUser } from 'types';
import { VendorTaskSchedule } from 'ux/Vendor/TaskSchedules/types';

type VendorState = {
  vendor: Vendor | null;
  vendorUsers: VendorUser[];
  tasks: VendorTaskListRow[];
  taskSchedules: VendorTaskSchedule[];
};

export const VENDOR_INITIAL_STATE: VendorState = {
  vendor: null,
  vendorUsers: [],
  tasks: [],
  taskSchedules: []
};

const vendorSlice = createSlice({
  name: 'Vendor',
  initialState: VENDOR_INITIAL_STATE,
  reducers: {
    setVendor: (state, action: PayloadAction<Vendor>) => {
      state.vendor = action.payload;
    },
    setVendorUsers: (state, action: PayloadAction<VendorUser[]>) => {
      state.vendorUsers = action.payload;
    },
    addVendorUser: (state, action: PayloadAction<VendorUser>) => {
      state.vendorUsers.push(action.payload);
    },
    updateVendorUser: (state, action: PayloadAction<Partial<VendorUser> & { id: number }>) => {
      const index = state.vendorUsers.findIndex(user => user.id === action.payload.id);
      if (index !== -1) {
        state.vendorUsers[index] = { ...state.vendorUsers[index], ...action.payload };
      }
    },
    removeVendorUser: (state, action: PayloadAction<{ id: number }>) => {
      state.vendorUsers = state.vendorUsers.filter(user => user.id !== action.payload.id);
    },
    setTasks: (state, action: PayloadAction<VendorTaskListRow[]>) => {
      state.tasks = action.payload;
    },
    setTaskSchedules: (state, action: PayloadAction<VendorTaskSchedule[]>) => {
      state.taskSchedules = action.payload;
    },
    updateTaskSchedule: (state, { payload }: PayloadAction<Updatable<VendorTaskSchedule>>) => {
      updateInList(state.taskSchedules, payload);
    },
    updateTask: (state, { payload }: PayloadAction<Updatable<VendorTaskListRow>>) => {
      updateInList(state.tasks, payload);
    }
  }
});

export const { actions } = vendorSlice;

export default vendorSlice.reducer;
